import styled from 'styled-components'

export const LabledFieldStyled = styled.div`
  margin-bottom: 24px;
`

export const Title = styled.label``
export const Field = styled.div``
